/**
 * Channel catalog card background gradients (ChannelCatalogCard.vue).
 * Each utility is a separate string literal for reliable Tailwind content scanning.
 *
 * Gradients: `bg-gradient-to-bl` — soft tint top-right → `to-n-solid-1`.
 * Pastel bases: `catalog-*` in tailwind.config.js; stops /15 and /5 (JIT-safe).
 */

const j = (...parts) => parts.join(' ');

/** @type {Record<string, string>} */
export const CATALOG_CARD_GRADIENT_CLASSES = {
  facebook: j(
    'bg-gradient-to-bl',
    'from-catalog-facebook/15',
    'via-catalog-facebook/5',
    'to-n-solid-1'
  ),
  tiktok: j(
    'bg-gradient-to-bl',
    'from-catalog-tiktok-pink/15',
    'via-catalog-tiktok-cyan/5',
    'to-n-solid-1'
  ),
  whatsapp: j(
    'bg-gradient-to-bl',
    'from-catalog-whatsapp/15',
    'via-green-400/5',
    'to-n-solid-1'
  ),
  whatsapp_browser: j(
    'bg-gradient-to-bl',
    'from-catalog-whatsapp-browser/15',
    'via-n-teal-4/5',
    'to-n-solid-1'
  ),
  instagram: j(
    'bg-gradient-to-bl',
    'from-catalog-instagram-1/15',
    'via-catalog-instagram-2/5',
    'to-n-solid-1'
  ),
  telegram: j(
    'bg-gradient-to-bl',
    'from-catalog-telegram/15',
    'via-n-blue-8/5',
    'to-n-solid-1'
  ),
  line: j(
    'bg-gradient-to-bl',
    'from-catalog-line/15',
    'via-green-600/5',
    'to-n-solid-1'
  ),
  website: j(
    'bg-gradient-to-bl',
    'from-n-blue-7/15',
    'via-n-iris-9/5',
    'to-n-solid-1'
  ),
  api: j(
    'bg-gradient-to-bl',
    'from-violet-500/15',
    'via-violet-300/5',
    'to-n-solid-1'
  ),
  sms: j(
    'bg-gradient-to-bl',
    'from-n-amber-9/15',
    'via-n-amber-11/5',
    'to-n-solid-1'
  ),
  email: j(
    'bg-gradient-to-bl',
    'from-n-ruby-9/15',
    'via-red-400/5',
    'to-n-solid-1'
  ),
  voice: j(
    'bg-gradient-to-bl',
    'from-n-teal-10/15',
    'via-n-teal-7/5',
    'to-n-solid-1'
  ),
};

export const CATALOG_CARD_GRADIENT_FALLBACK_CLASS = j(
  'bg-gradient-to-bl',
  'from-n-slate-9/15',
  'via-n-slate-11/5',
  'to-n-solid-1'
);

/**
 * @param {string|null|undefined} key - catalog / connect-flow channel key
 * @returns {string}
 */
export function getCatalogCardGradientClassForChannelKey(key) {
  if (!key || typeof key !== 'string')
    return CATALOG_CARD_GRADIENT_FALLBACK_CLASS;
  return (
    CATALOG_CARD_GRADIENT_CLASSES[key] || CATALOG_CARD_GRADIENT_FALLBACK_CLASS
  );
}
